import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.css']
})
export class PartnersComponent implements OnInit {
  title = 'ITARIUM Technologies India Pvt. Ltd. | Associations';
  constructor(private titleService: Title, private meta:Meta) { 
  }

  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.meta.addTags([
      {name: 'keywords', content: 'BMC, BMC Softwares, BMC Tools, Itarium Technologies, G-Suite, Microsoft, Taxbuddy, Shephertz' },
      {name: 'description', content: 'ITARIUM works with many organizations to provide better IT solutions and services as per their requirements.'},
      {name: 'robots', content: 'index, follow'}
    ]);
    window.scrollTo(0, 0)
  }

}
